/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { Table, CustomInput, FormGroup } from "reactstrap";
import { Auth } from "aws-amplify";
import IntlMessages from "../../../helpers/IntlMessages";
import ScrollButton from "../../../components/gotoTopScrollButton/ScrollButton";

const ringTones = [
  {
    name: "Door Bell",
    file: "doorbell"
  },
  {
    name: "Telephone",
    file: "cartoon-telephone_daniel_simion"
  },
  {
    name: "Bell Notification",
    file: "bell-notification-933"
  },
  {
    name: "Clear Announce",
    file: "clear-announce-tones-2861"
  },
  {
    name: "Correct Answer",
    file: "correct-answer-reward-952"
  },
  {
    name: "Happy Bells",
    file: "happy-bells-notification-937"
  },
  {
    name: "Musical Reveal",
    file: "musical-reveal-961"
  },
  {
    name: "Short Bell",
    file: "shortbell"
  }
];

const Ringtone = () => {
  const [currentRingTone, setRingTone] = useState(null);

  const getRingtone = async () => {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    if (!currentRingTone) {
      const { attributes } = user;
      const ringTone = attributes["custom:ringTone"] || "doorbell";
      setRingTone(ringTone);
    }
    await Auth.updateUserAttributes(user, { "custom:ringTone": currentRingTone });
    const insertAudio = new Audio(`/assets/sounds/${currentRingTone}.mp3`);
    if (insertAudio && insertAudio.play) {
      insertAudio.muted = false;
      insertAudio.play().then(() => {
        setTimeout(() => {
          insertAudio.muted = true; // After playing, turn on the mute state
        }, 5000);
      });
    }
  };

  const changeRingtone = async e => {
    const { value } = e.target;
    setRingTone(value);
  };

  useEffect(() => {
    getRingtone();
  }, [currentRingTone]);

  return (
    <>
      <Table className="mt-3" bordered responsive striped style={{ overflow: "hidden" }}>
        <thead>
          <tr>
            <th>
              <IntlMessages id="ringTone.sound" />
            </th>
            <th>
              <IntlMessages id="ringTone.playChoose" />
            </th>
          </tr>
        </thead>
        <tbody>
          {ringTones &&
            ringTones.map(({ name, file }, index) => (
              <tr key={index}>
                <td>{name}</td>
                <td>
                  <FormGroup>
                    <div>
                      <CustomInput id={`${name}-${index}`} checked={currentRingTone === file}
                        type="radio" name="customRadio" value={file}
                        onChange={changeRingtone}
                      />
                    </div>
                  </FormGroup>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <ScrollButton />
    </>
  );
};

export default injectIntl(Ringtone);
